import { z } from 'zod';
import { $t } from '../../plugins/fluent';
import { LinkSchema } from '../MultiLink/schema';

export const REQUIRED_STRING = z.string().min(1, $t('input-required'));
export const OPTIONAL_STRING = z.string();
export const OPTIONAL_TEXT = z.string().max(250, $t('max-characters', { count: 250 }));
export const OPTIONAL_TEXT_3000 = z
    .string()
    .max(3000, $t('max-characters', { count: 3000 }))
    .trim();
export const OPTIONAL_YEAR = z.coerce
    .number({ invalid_type_error: $t('expected-number') })
    .optional()
    .transform((val, ctx) => {
        if (val === undefined || val === 0) return undefined;
        if (val < 1000 || val > 2099) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: $t('number-between', { start: '1000', end: '2099' }),
            });
        }
        return val;
    });

export const YEAR = z.coerce.number({ invalid_type_error: $t('expected-number') }).transform((val, ctx) => {
    if (val === undefined || val === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: $t('input-required'),
        });
    }
    if (val < 1000 || val > 2099) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: $t('number-between', { start: '1000', end: '2099' }),
        });
    }
    return val;
});

export const NULL_BOOLEAN = z.boolean().nullable().optional();
export const BOOLEAN = z.boolean();
export const MULTILINK = z.array(LinkSchema);
export const DROPDOWN_STRING = z
    .object({ id: z.string(), name: z.string() })
    .nullable()
    .refine((status) => status !== null, { message: $t('input-required') });

export const MULTILINK_CRUD = z.array(
    z.object({
        id: z.string(),
        name: REQUIRED_STRING,
        to: REQUIRED_STRING,
        description: OPTIONAL_STRING,
        status: z.string(),
    }),
);
